var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-6 w-6 rounded-full flex justify-center items-center",class:_vm.properties.backgroundColor,attrs:{"title":_vm.properties.title}},[_c(_vm.properties.component,{tag:"component",staticClass:"text-white"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }